/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const QUARTERlY_MARKETING_GRID_DATA = 'QUARTERlY_MARKETING_GRID_DATA';
export const QUARTERlY_MARKETING_BEGQTR = 'QUARTERlY_MARKETING_BEGQTR';
export const QUARTERlY_MARKETING_ENDQTR = 'QUARTERlY_MARKETING_ENDQTR';
export const QUARTERlY_MARKETING_REBATE_CD = 'QUARTERlY_MARKETING_REBATE_CD';
export const QUARTERlY_MARKETING_PLAN_TYPE = 'QUARTERlY_MARKETING_PLAN_TYPE';
export const SET_ERROR_MESSAGES = 'SET_ERROR_MESSAGES';
export const RESET_QUARTERLY_MARKETIING_STORE = 'RESET_QUARTERLY_MARKETIING_STORE';
export const SET_MAX_FROZEN_QTR = 'SET_MAX_FROZEN_QTR';
